import { render } from "./AdministratorsTable.vue?vue&type=template&id=3e364969"
import script from "./AdministratorsTable.vue?vue&type=script&lang=js"
export * from "./AdministratorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__